export default __webpack_public_path__ + "static/media/aggro.5c35c168.wav";